var exports = {
  "O0": "MenuItemRadio.module__radioButton___a3M1LV",
  "X3": "MenuItemRadio.module__radioButtonSelected___a3M1LV",
  "EC": "MenuItemRadio.module__radioButtonUnselected___a3M1LV",
  "$l": "MenuItemRadio.module__radioIndicator___a3M1LV",
  "aT": "MenuItemRadio.module__labelContent___a3M1LV",
  "Kk": "MenuItemRadio.module__icon___a3M1LV",
  "QK": "MenuItemRadio.module__labelText___a3M1LV",
};

module.exports = exports;
